import React from 'react';
import Layout from '../components/Layout/Layout';
import ProjectList from '../components/Projects/ProjectList';

const ProjectsPage = () => {
  return (
    <Layout>
      <ProjectList />
    </Layout>
  );
};

export default ProjectsPage;
